module.exports = __webpack_public_path__ + "assets/img/37_1482.e578b3fd.jpg";